import { actions } from './actionTypes'
import apiClient from '../utils/apiClient'
import { createSignUri } from "../utils/signLink"

export const archiveIdReceived = data => {
  return {
    type: actions.ARCHIVE_ID_RECEIVED,
    payload: data
  }
}

export const requestIdReceived = data => {
  return {
    type: actions.REQUEST_ID_RECEIVED,
    payload: data
  }
}

export const setUploadState = (success, statusCode = null, responseData = null) => {
  return {
    type: actions.SET_UPLOAD_STATE,
    payload: { success, statusCode, responseData }
  }
}
export const setLastUpload = (data) => ({
  type: actions.SET_LAST_UPLOAD,
  payload: data
})

export const uploadFile = (data) => (dispatch, getState) => {
  const options = {
    method: 'POST',
    data: data,
    url: `${process.env.REACT_APP_API}/api/upload`,
    headers: {
      'Content-Type': false
    }
  }

  apiClient(options).then(
    response => {
      dispatch(archiveIdReceived(response.data.id))
      dispatch(setLastUpload(response.data))
      dispatch(setUploadState(true, response.status))
    },
    error => {
      const response = error.response
      dispatch(setUploadState(false, response.status, response.data))
    }
  )
}

export const createSigningJob = (id) => (dispatch, getState) => {
  const options = {
    method: 'POST',
    url: createSignUri(id)
  }

  apiClient(options).then(
    response => {
      dispatch(requestIdReceived(response.data.id))
    },
    error => console.log('Error: ' + error)
  )
}

/**
 *
 * @param {requestId} id
 * @param {mongoDbId} mongoDbId
 */
export const checkStatus = (id, mongoDbId) => (dispatch, getState) => {
  const options = {
    method: 'POST',
    data: {
      requestId: id,
      mongoDbId: mongoDbId
    },
    url: `${process.env.REACT_APP_API}/api/status`,
    json: true
  }

  apiClient(options).then(
    response => console.log('Response: ' + response),
    error => console.log(error)
  )
}
